<template>
  <div class="section fondu" :class="{'fonduenter': settings.length}">

    <!-- notification -->
    <transition mode="out-in" name="fade">
      <div v-if="notification.message" :class="'notification is-' + notification.type">
        <button class="delete" @click="hideNotifications"></button>{{notification.message}}
      </div>
    </transition>

    <div class="card">
      <div class="card-header">
        <p class="card-header-title">Base de données</p>
        <span class="icon has-text-info help-btn">
          <a href="https://theadmin.thecompagnie.eu/doc?bloc=Base%20de%20données" target="_blank"><i class="fa fa-question-circle"></i></a>
        </span>
      </div>
      <div class="card-content principal">
        <div class="content">
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">État de la base de données</p>
            </div>
            <div class="card-content">
              <div class="content">
                <div>
                  Paramètres:
                  <span v-if="settings.length === 0" class="has-text-danger">
                    Vide
                    <button class="button is-info" @click="addDemoSettings">Ajouter Démo Paramètres</button>
                  </span>
                  <span v-else class="has-text-success">Contient des données</span>
                </div>

                <div>
                  Média:
                  <span v-if="media.length === 0" class="has-text-danger">
                    Vide
                    <button class="button is-info" @click="addDemoLogo">Ajouter Démo Logo</button>
                  </span>
                  <span v-else class="has-text-success">Contient des données</span>
                </div>

                <div>
                  Navigation:
                  <span v-if="nav.length === 0" class="has-text-danger">
                    Vide <button class="button is-info" @click="addDemoNav">Ajouter Démo Navigation</button>
                  </span>
                  <span v-else class="has-text-success">Contient des données</span>
                </div>

                 <div>
                  Contenu:
                  <span v-if="contents.length === 0" class="has-text-danger">
                    Vide
                    <button class="button is-info" @click="addDemoContent">Ajouter Démo Contenu</button>
                  </span>
                  <span v-else class="has-text-success">Contient des données</span>
                </div>

                 <div>
                  Champs:
                  <span v-if="fields.length === 0" class="has-text-danger">
                    Vide
                    <button class="button is-info" @click="addDemoFields">Ajouter Démo Champs</button>
                  </span>
                  <span v-else class="has-text-success">Contient des données</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import {demoData} from '@/../theadmin.config.json'
import notifier from '@/admin/mixins/notifier'
import { settingsRef, mediaRef, navRef, contentsRef, fieldsRef, routesRef } from '@/admin/firebase_config'
import _ from 'lodash'

export default {
  data () {
    return {...demoData, con: ''}
  },
  firebase: {
    settings: settingsRef,
    media: mediaRef,
    nav: navRef,
    fields: fieldsRef,
    contents: contentsRef,
    routes: routesRef
  },
  mixins: [notifier],
  methods: {
    addDemoPost () {
      let storageRef = firebase.storage().ref()
      let postImageRef = storageRef.child('images/demo-post-img.png')
      let imgDownloadURL = ''

      this.fetchLogoBlob()
        .then(blob => {
          return postImageRef.put(blob)
        })
        .then(snapshot => {
          imgDownloadURL = snapshot.downloadURL
          let demoPost = {...this.demoPost}
          demoPost.created = Date.now()
          demoPost.img = imgDownloadURL
          demoPost.body += `<p><img src="${imgDownloadURL}"></p>`
          const key = _.find(this.contents, { 'name': 'Posts' })['.key']
          return this.$firebaseRefs.contents.child(key + '/data').push(demoPost)
        })
        .then(() => {
          return this.$firebaseRefs.media.push({
            name: 'demo-post-img.png',
            path: postImageRef.fullPath,
            src: imgDownloadURL
          })
        })
        .then(() => {
          // this.showNotification('success', 'Demo Content added successfully')
        })
    },
    addDemoNews () {
      let storageRef = firebase.storage().ref()
      let postImageRef = storageRef.child('images/demo-post-img.png')
      let imgDownloadURL = ''

      this.fetchLogoBlob()
        .then(blob => {
          return postImageRef.put(blob)
        })
        .then(snapshot => {
          imgDownloadURL = snapshot.downloadURL
          let demoNews = {...this.demoNews}
          demoNews.img = imgDownloadURL
          return this.$firebaseRefs.contents.child(this.con + '/data').push(demoNews)
        })
        .then(() => {
          return this.$firebaseRefs.media.push({
            name: 'demo-post-img.png',
            path: postImageRef.fullPath,
            src: imgDownloadURL
          })
        })
        .then(() => {
          this.addDemoRoutesForNews()
          this.showNotification('success', 'Démo Contenu ajouté avec succés')
        })
    },
    addDemoRoutesForNews () {
      let i = this.demoRoutes.length
      this.demoRoutes.forEach(route => {
        this.$firebaseRefs.routes.push(route)
          .then(() => {
            i--
            if (i === 0) {
              this.showNotification('success', 'Démo Chemin ajouté avec succés')
            }
          })
      })
    },
    addDemoSettings () {
      this.$firebaseRefs.settings.update(this.demoSettings)
        .then(() => {
          this.showNotification('success', 'Démo Paramètres ajouté avec succés')
        })
    },
    addDemoNav () {
      let i = this.demoNav.length
      this.demoNav.forEach(link => {
        this.$firebaseRefs.nav.push(link)
          .then(() => {
            i--
            if (i === 0) {
              this.showNotification('success', 'Démo Navigation ajouté avec succés')
            }
          })
      })
    },
    addDemoLogo () {
      let storageRef = firebase.storage().ref()
      let logoRef = storageRef.child(`images/TheAdminlogo.png`)

      this.fetchLogoBlob()
        .then(blob => {
          logoRef
            .put(blob)
            .then(snapshot => {
              this.addDemoLogoToDB(snapshot)
            })
        })
    },
    fetchLogoBlob () {
      return fetch(this.demoLogoLink)
        .then(res => {
          return res.blob()
        })
    },
    addDemoLogoToDB (snapshot) {
      this.$firebaseRefs.media.push({
        name: 'WebsiteLogo',
        path: snapshot.ref.fullPath,
        src: snapshot.downloadURL
      })
        .then(() => {
          this.showNotification('success', 'Demo Logo added successfully')
        })
    },
    addDemoFields () {
      let i = this.demoFields.length
      this.demoFields.forEach(field => {
        this.$firebaseRefs.fields.push(field)
          .then(() => {
            i--
            if (i === 0) {
              this.showNotification('success', 'Demo fields added successfully')
            }
          })
      })
    },
    addDemoContent () {
      let i = this.demoContent.length

      this.demoContent.forEach(content => {
        this.$firebaseRefs.contents.push(content)
          .then((c) => {
            i--
            if (i === 0) {
              this.con = c.key
              this.addDemoPost()
              this.addDemoNews()
            }
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/Database.vue